<template>
	<v-container id="regular-tables-view" fluid tag="section">
		<material-card icon="mdi-format-list-numbered-rtl" icon-small title="گزارش قراردادهای امضای دیجیتال" color="accent" :loading="loading">
			<v-row>
				<v-col cols="12" style="padding:0 40px 40px">
					<v-row>
						<v-col cols="12" md="3">
						</v-col>
						<v-col cols="12" md="6">
							<date-navigator v-model="dateRange" :options="{ rangeMode: true }">
								<div class="text-center">
									<v-btn small color="primary" dark class="mx-1" @click="loadData">
										دریافت اطلاعات
									</v-btn>
								</div>
							</date-navigator>
						</v-col>
						<v-col cols="12" md="3" class="d-flex align-center justify-end">
							<export-excel :items="filteredItems" :headers="headers" :fileName="excelFileName">
							</export-excel>
						</v-col>
					</v-row>
					<v-row>
						<v-col cols="12" v-if="contractStatuses.length">
							<v-btn-toggle v-model="statusFilter" dense tile outlined color="purple" class="mr-2 flex-wrap">
								<v-btn v-for="status in contractStatuses" :key="status.status" :value="status.status" small>
									{{ status.str_Status }}
									<v-badge color="blue" :content="status.status === 'همه' ? items.length : items.filter(x => x.status == status.status).length || '0'" inline>
									</v-badge>
								</v-btn>
							</v-btn-toggle>
						</v-col>
						<v-col cols="12" md="8">
							<v-text-field v-model="search" append-icon="mdi-magnify" label="اطلاعات مورد نظر خود جهت جستجو وارد کنید" single-line hide-details class="mb-5" />
						</v-col>
						<v-col cols="12">
							<v-data-table :height="dataTableFixedHeight - 200" fixed-header :headers="headers" :items="filteredItems" :footer-props="{ 'items-per-page-options': [5, 15, 50, 100] }" :items-per-page="50" :search="search" class="elevation-1">
								<template v-slot:item="row">
									<tr>
										<td>
											<div @click="manageLoanRequest(row.item)" style="cursor:pointer">
												<div class="info--text">شماره درخواست: {{ row.item.code }}</div>
											</div>
										</td>
										<td>
											<div @click="manageLoanRequest(row.item)" style="cursor:pointer">
												<div><small>{{ row.item.fullName }}</small></div>
												<div><small>{{ row.item.mobile }}</small></div>
												<div><small>کد ملی: {{ row.item.nationalCode }}</small></div>
											</div>
										</td>
										<td class="text-right">
											{{ row.item.agentBusinessName }}
										</td>
										<td class="text-right">
											{{ row.item.title }}
										</td>
										<td class="text-center">
											{{ row.item.amount.toString().toPriceFormat() }}
										</td>
										<td class="text-center">
											{{ row.item.date }}
										</td>
										<td class="text-center">
											{{ row.item.str_Status }}
										</td>
									</tr>
								</template>
							</v-data-table>
						</v-col>
					</v-row>
				</v-col>
			</v-row>
		</material-card>
		<confirm-dlg ref="confirm" />
		<div class="py-3" />
		<v-dialog v-model="dialogModifyRequest" scrollable persistent max-width="1100px">
			<modify-request ref="modifyRequest" v-if="dialogModifyRequest" :data="selectedLoanRequest" @close="dialogModifyRequest = false" />
		</v-dialog>
	</v-container>
</template>

<script>
	import api from '@/util/app-api'
	import toast from '@/util/toast'
	import VuePersianDatetimePicker from 'vue-persian-datetime-picker'

	export default {
		name: 'DigitalSignContracts',
		props: {
			reportTitle: { type: String, default: '' },
		},
		components: {
			ConfirmDlg: () => import('@/components/Confirm'),
			'modify-request': () => import('@/views/admin/ModifyLoanRequest.vue'),
			'date-navigator': () => import('@/components/DateNavigator'),
			'date-picker': VuePersianDatetimePicker,
		},
		data() {
			return {
				dialogModifyRequest: false,
				selectedLoanRequest: {},
				errorMessages: '',
				startDateValidatioin: '',
				endDateValidatioin: '',
				search: '',
				loading: false,
				headers: [
					{
						text: 'شماره درخواست',
						align: 'center',
						sortable: true,
						value: 'code',
					}, {
						text: 'مشتری',
						align: 'start',
						sortable: true,
						value: 'fullName',
						width: '220'
					}, {
						text: 'نماینده',
						align: 'start',
						sortable: true,
						value: 'agentBusinessName',
						width: '150'
					}, {
						text: 'عنوان وام',
						align: 'start',
						sortable: true,
						value: 'title',
						width: '250'
					}, {
						text: 'کد ملی',
						align: ' d-none',
						sortable: true,
						value: 'nationalCode',
					}, {
						text: 'موبایل',
						align: ' d-none',
						sortable: true,
						value: 'mobile',
					}, {
						text: 'مبلغ وام',
						align: 'center',
						sortable: true,
						value: 'amount',
						excel_value: '%root%',
						excel_callback: (value) => {
							return value.amount.toString()
						}
					}, {
						text: 'تاریخ درخواست',
						align: 'center',
						sortable: true,
						value: 'date',
					}, {
						text: 'وضعیت قرارداد',
						align: 'center',
						sortable: true,
						value: 'str_Status',
					},
				],
				items: [],
				dateRange: { start: new Date(new Date().setMonth(new Date().getMonth() - 1)).toJSON(), end: '' },
				statusFilter: 'همه',
				contractStatuses: [],
			}
		},
		computed: {
			excelFileName() {
				let name = 'گزارش قراردادها'
				if (this.dateRange.start)
					name += ' از ' + this.dateRange.start.toString().split('T')[0]
				if (this.dateRange.end)
					name += ' تا ' + this.dateRange.end.toString().split('T')[0]
				name += '.xls'
				return name
			},
			filteredItems() {
				if (!this.statusFilter)
					return this.items

				let clonedItems = []
				clonedItems.push(...this.items)

				if (this.statusFilter !== 'همه')
					clonedItems = clonedItems.filter(x => x.status === this.statusFilter)

				return clonedItems
			}
		},
		created() {
			if (this.autoSubmit) {
				this.dateNavigatorOptions = { rangeMode: true, defaultEmpty: true }
			}
		},
		mounted() {

		},
		methods: {
			manageLoanRequest(item) {
				this.selectedLoanRequest = {
					id: item.id,
				}
				this.dialogModifyRequest = true
			},
			loadData() {
				this.loading = true
				api.get('admin/report/DigitalSignContracts/?start=' + this.dateRange.start + '&end=' + this.dateRange.end, {})
					.then(
						response => {
							this.items = response
							this.contractStatuses = Object.values(
								response.reduce((acc, obj) => ({ ...acc, [obj.loanId]: { status: obj.status, str_Status: obj.str_Status } }), {})
							)
							if (this.contractStatuses.length) {
								this.contractStatuses.push({ status: 'همه', str_Status: 'همه' })
							}
						})
					.catch(err => {
						toast.error(err.message)
					})
					.finally(x => { this.loading = false })
			}
		},
	}
</script>
<style></style>
